<!-- ===================== SOPORTE (cabecera + tarjetas) ===================== -->
<section class="support" id="soporte">
  <div class="support-head">
    <span class="eyebrow">{{ 'soporte.eyebrow' | translate }}</span>
    <h1 class="section-title">{{ typed }}</h1>
    <p class="section-lead center">{{ 'soporte.lead' | translate }}</p>
  </div>

  <div class="support-grid">
    <a class="support-card" *ngFor="let i of cardIndexes" [href]="cards[i].url" target="_blank" rel="noopener">
      <div class="tile"><img [src]="cards[i].icon" alt=""></div>
      <p>{{ 'soporte.cards.' + i | translate }}</p>
    </a>
  </div>
</section>

<!-- ===================== CONTACTO SOPORTE ===================== -->
<section class="support-contact">
  <div class="feature-block">
    <div class="contact-block">
      <h3>{{ 'soporte.contactTitle' | translate }}</h3>
      <div class="contact-line">
        <span class="ico"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3 7 9 6 9-6"/></svg></span>
        <a href="mailto:soporte@gesvatec.com" [innerHTML]="'soporte.emailHtml' | translate"></a>
      </div>
      <div class="contact-line">
        <span class="ico"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6.6 10.8a15 15 0 0 0 6.6 6.6l2.2-2.2a1 1 0 0 1 1-.25 11 11 0 0 0 3.5.56 1 1 0 0 1 1 1V20a1 1 0 0 1-1 1A17 17 0 0 1 3 4a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1 11 11 0 0 0 .56 3.5 1 1 0 0 1-.25 1Z"/></svg></span>
        <a href="tel:+34963939160" [innerHTML]="'soporte.phoneHtml' | translate"></a>
      </div>

      <div class="gst">
        <h4 [innerHTML]="'soporte.gstTitleHtml' | translate"></h4>
        <div class="quality" *ngFor="let i of gstItems">
          <span class="check"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg></span>
          <p>{{ 'soporte.gstItems.' + i | translate }}</p>
        </div>
      </div>
    </div>
    <div class="fb-media">
      <img [src]="illus" [alt]="'soporte.illusAlt' | translate" onerror="this.style.display='none'">
    </div>
  </div>
</section>
